/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ xp: NonNullable<unknown> }} Perks_Head_XpInputs */



/**
* | output |
* | --- |
* | "{xp} XP" |
*
* @param {Perks_Head_XpInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const perks_head_xp = /** @type {((inputs: Perks_Head_XpInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Perks_Head_XpInputs, { locale?: "en" | "ru" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ (`${i?.xp} XP`)
	return /** @type {LocalizedString} */ (`${i?.xp} XP`)
});